/*
  Diesel Proof — product page Add to cart row.

  Dawn renders the quantity selector and the buy buttons as sibling blocks, and
  dp-product-layout.css puts them side by side in the info container's grid.
  That breaks down once an app injects into the product form: Hulk Product
  Options renders its block inside <form>, which lives in the right-hand column,
  so a wide options panel ends up squeezed next to the quantity box.

  The options block cannot move out of the form — its inputs have to submit with
  the add-to-cart request. So the quantity block moves in instead, and the form
  itself becomes the row container.

  No wrapper element, deliberately. Hulk injects its block immediately before
  .product-form__buttons, so wrapping the button in anything just means Hulk
  renders inside that wrapper too. Instead the form is a wrapping flex container
  and CSS `order` pins quantity and the buttons to the last line; anything an app
  injects keeps the default order and lands above them, wherever in the form it
  happens to insert itself.

  Dawn already gives the quantity input a `form` attribute, so nothing about
  submission changes — it just sits inside the form it was already posting to.

  The container gets a marker class so the CSS only rearranges once this has
  actually run. With JS off, Dawn's original grid layout stands.
*/
(function () {
  const READY_CLASS = 'product__info-container--atc-row-ready';

  function placeQuantity(scope) {
    const containers = (scope || document).querySelectorAll('.product__info-container--inline-atc');

    containers.forEach((container) => {
      const form = container.querySelector('.product__buy-buttons form.form');
      const buttons = form && form.querySelector('.product-form__buttons');
      const quantity = container.querySelector('.product-form__quantity');

      if (!quantity || !form || !buttons) return;
      if (quantity.parentElement !== form) {
        form.insertBefore(quantity, buttons);
      }

      container.classList.add(READY_CLASS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => placeQuantity());
  } else {
    placeQuantity();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', (event) => placeQuantity(event.target));
})();
